/* NUVERY homepage behaviours: fit-text display words, campaign slider, category hover thumbnail, header nav split */
(function () {
  'use strict';

  /* ---------- fit a single line of text to its container width ---------- */
  function textWidth(el) {
    var range = document.createRange();
    range.selectNodeContents(el);
    return range.getBoundingClientRect().width;
  }
  function fit(el) {
    var box = el.parentElement;
    if (!box) return;
    var share = parseFloat(el.getAttribute('data-nv-fit')) || 1;
    var target = box.clientWidth * share;
    el.style.fontSize = '100px';
    el.style.whiteSpace = 'nowrap';
    var w = textWidth(el);
    if (!w) return;
    var size = (100 * target) / w;
    var max = parseFloat(el.getAttribute('data-nv-fit-max')) || Infinity;
    el.style.fontSize = Math.min(size, max).toFixed(2) + 'px';
    /* expose the word's rendered height so text above it can anchor to it (hero label + tagline) */
    if (el.hasAttribute('data-nv-fit-report')) {
      var range = document.createRange();
      range.selectNodeContents(el);
      var g = range.getBoundingClientRect();
      var b = box.getBoundingClientRect();
      box.style.setProperty('--nv-word-h', Math.max(0, Math.round(b.bottom - g.top)) + 'px');
    }
  }
  function fitAll() {
    var els = document.querySelectorAll('[data-nv-fit]');
    for (var i = 0; i < els.length; i++) fit(els[i]);
  }
  function whenFontsReady(fn) {
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fn);
    else fn();
  }

  /* ---------- campaign slider ---------- */
  function initSlider(root) {
    if (root.__nv) return;
    root.__nv = true;
    var viewport = root.querySelector('.nv-slider__viewport');
    var track = root.querySelector('.nv-slider__track');
    if (!viewport || !track) return;
    var slides = track.children;
    var dots = root.querySelectorAll('.nv-slider__dot');
    var index = 0;

    function step() {
      if (!slides.length) return 0;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || 0) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }
    function visible() {
      var s = step();
      return s ? Math.max(1, Math.floor((viewport.clientWidth + 1) / s)) : 1;
    }
    function maxIndex() {
      return Math.max(0, slides.length - visible());
    }
    function go(n) {
      index = Math.max(0, Math.min(maxIndex(), n));
      track.style.transform = 'translateX(' + (-index * step()) + 'px)';
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === index);
    }
    var prev = root.querySelector('[data-nv-prev]');
    var next = root.querySelector('[data-nv-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    for (var i = 0; i < dots.length; i++) {
      (function (k) { dots[k].addEventListener('click', function () { go(k); }); })(i);
    }
    window.addEventListener('resize', function () { go(index); });
    go(0);
  }

  /* ---------- category list: hover swaps the thumbnail ---------- */
  function initCats(root) {
    if (root.__nv) return;
    root.__nv = true;
    var img = root.querySelector('.nv-cat__thumb img');
    var items = root.querySelectorAll('.nv-cat__item');
    function activate(it) {
      for (var i = 0; i < items.length; i++) items[i].classList.remove('is-active');
      it.classList.add('is-active');
      var src = it.getAttribute('data-image');
      if (img && src) {
        img.removeAttribute('srcset');
        img.src = src;
      }
    }
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('mouseenter', function () { activate(this); });
      items[i].addEventListener('focus', function () { activate(this); });
    }
  }

  /* ---------- header: move the second half of the desktop menu to the right of the mark ---------- */
  function splitNav() {
    var header = document.getElementById('header-component');
    if (!header || window.innerWidth < 990) return;
    var left = header.querySelector('.header__column--left');
    var right = header.querySelector('.header__column--right');
    if (!left || !right || right.querySelector('.nv-nav-right')) return;
    var list = left.querySelector('overflow-list') || left.querySelector('.menu-list__list');
    if (!list) return;
    /* only top-level items whose own direct child is the link — skips the theme's "More" overflow item and its submenu copies */
    var items = [];
    var children = list.children;
    for (var i = 0; i < children.length; i++) {
      var li = children[i];
      var direct = null;
      for (var c = 0; c < li.children.length; c++) {
        if (li.children[c].matches && li.children[c].matches('a.menu-list__link')) { direct = li.children[c]; break; }
      }
      if (direct && !li.querySelector(':scope > button')) items.push({ li: li, a: direct });
    }
    if (items.length < 3) return;
    /* keep the smaller half on the left of the mark, the larger half on the right (4 → 2|2, 5 → 2|3) */
    var keep = Math.floor(items.length / 2);
    var moveCount = items.length - keep;
    /* clone the second half into the right column; hide the originals structurally (nth-child), because the
       theme's <overflow-list> re-renders its children and would drop any class or attribute we set on them */
    var ul = document.createElement('ul');
    ul.className = 'nv-nav-right';
    for (var k = keep; k < items.length; k++) {
      var nli = document.createElement('li');
      var na = document.createElement('a');
      na.className = 'menu-list__link';
      na.href = items[k].a.getAttribute('href');
      na.textContent = items[k].a.textContent.trim();
      nli.appendChild(na);
      ul.appendChild(nli);
    }
    right.insertBefore(ul, right.firstChild);
    if (!document.getElementById('nv-nav-split-style')) {
      var st = document.createElement('style');
      st.id = 'nv-nav-split-style';
      st.textContent = "@media (min-width:990px){#header-component[data-menu-style='menu'] .header__column--left overflow-list > li:nth-child(n+" + (keep + 1) + "),#header-component[data-menu-style='menu'] .header__column--left .menu-list__list > li:nth-child(n+" + (keep + 1) + "){display:none !important}}";
      document.head.appendChild(st);
    }
  }

  function init() {
    var sliders = document.querySelectorAll('[data-nv-slider]');
    for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
    var cats = document.querySelectorAll('[data-nv-cats]');
    for (var j = 0; j < cats.length; j++) initCats(cats[j]);
    splitNav();
    whenFontsReady(fitAll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', fitAll);
  /* fonts load lazily on first use, so fonts.ready can resolve before Anton is even requested — re-fit when it lands */
  if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fitAll);
  setTimeout(fitAll, 700);
  setTimeout(fitAll, 2200);
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { splitNav(); fitAll(); }, 120);
  });
  document.addEventListener('shopify:section:load', init);
})();
